// ConstructionSystem — turns the queued construction jobs into real
// structures when their works finish. Driven by DAY_CHANGED so it pauses
// with the game and scales with speed. React never completes jobs itself;
// it only enqueues (queueConstruction) and reads the queue.

import { EventBus, GameEvents, type ConstructionCompletedPayload } from '../utils/EventBus'
import { useGameStore } from '@/store/gameStore'

export class ConstructionSystem {
  private handler = () => this.completeDueJobs()

  constructor() {
    EventBus.on(GameEvents.DAY_CHANGED, this.handler)
    // Defensive sweep on init (e.g. after loading a save mid-works)
    this.completeDueJobs()
  }

  destroy() {
    EventBus.off(GameEvents.DAY_CHANGED, this.handler)
  }

  private completeDueJobs() {
    const store = useGameStore.getState()
    const due = store.constructionQueue.filter(j => j.endDay <= store.day)
    if (due.length === 0) return

    for (const job of due) {
      const completed = useGameStore.getState().completeConstruction(job.id)
      if (!completed) continue

      // Courts revive the legacy notification + tutorial step + build SFX
      if (completed.kind === 'court') {
        EventBus.emit(GameEvents.COURT_PLACED, { type: completed.courtType })
      }

      const payload: ConstructionCompletedPayload = {
        kind: completed.kind,
        label: completed.label,
      }
      EventBus.emit(GameEvents.CONSTRUCTION_COMPLETED, payload)
    }

    // A finished building may unlock the next club level
    useGameStore.getState().checkLevelUp()
  }
}
